import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideImages } from '../data/insideImages';
export function InsideCarousel() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const total = insideImages.length;
  const go = (step: number) => {
    setState(([current]) => [(current + step + total) % total, step]);
  };
  const image = insideImages[index];
  return <section className="border-y border-brand-line bg-brand-blush px-4 py-20 sm:py-28" data-id="element-155" data-mp="2awcd1kyl6eq0">
      <div className="mx-auto max-w-5xl" data-id="element-156" data-mp="2omzdpinwqeoq">
        <div className="text-center" data-id="element-157" data-mp="2olxqygxj43r6">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-158" data-mp="2op1ztrlxvno6">
            Voyez l’intérieur du système
          </p>
          <h2 className="mx-auto mt-3 max-w-2xl text-3xl font-semibold text-brand-ink sm:text-4xl" data-id="element-159" data-mp="2ymgfhp01g8ff">
            Un contenu visuel, structuré et pensé pour une utilisation réelle
            en cours.
          </h2>
        </div>

        <div className="relative mx-auto mt-12 max-w-xl" role="region" aria-roledescription="carrousel" aria-label="Pages intérieures du système" data-id="element-160" data-mp="2muv6i2aga30z">
          <div className="relative overflow-hidden rounded-2xl border border-brand-line bg-white p-3 shadow-soft" data-id="element-161" data-mp="2wpww0z8n1743">
            <div className="relative aspect-[4/5] overflow-hidden rounded-xl bg-brand-cream" data-id="element-162" data-mp="30qp9k4ojly66">
              <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-163" data-mp="35psc9ih1vsaz">
                <motion.img key={image.src} src={image.src} alt={image.alt} custom={direction} initial={{
                opacity: 0,
                x: direction >= 0 ? 40 : -40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction >= 0 ? -40 : 40
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.2} onDragEnd={(_, info) => {
                if (info.offset.x < -60) go(1);
                if (info.offset.x > 60) go(-1);
              }} className="absolute inset-0 h-full w-full cursor-grab object-contain active:cursor-grabbing" draggable={false} data-id="element-164" data-mp="3ap4zi4bu31e3" />
              </AnimatePresence>
            </div>
          </div>

          <button type="button" onClick={() => go(-1)} aria-label="Image précédente" className="absolute left-0 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-brand-line bg-white text-brand-ink shadow-card transition-colors duration-150 hover:bg-brand-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral sm:-translate-x-[130%]" data-id="element-165" data-mp="284nec781vjf6">
            <ChevronLeftIcon size={20} aria-hidden="true" data-id="element-166" data-mp="2ye4jfxhxf6ae" />
          </button>
          <button type="button" onClick={() => go(1)} aria-label="Image suivante" className="absolute right-0 top-1/2 flex h-11 w-11 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full border border-brand-line bg-white text-brand-ink shadow-card transition-colors duration-150 hover:bg-brand-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral sm:translate-x-[130%]" data-id="element-167" data-mp="2yg7krdoj4luf">
            <ChevronRightIcon size={20} aria-hidden="true" data-id="element-168" data-mp="2knj3agjuxag7" />
          </button>

          <div className="mt-6 flex justify-center gap-2" data-id="element-169" data-mp="26o04iecxrbgk">
            {insideImages.map((item, dotIndex) => <button key={item.src} type="button" onClick={() => setState([dotIndex, dotIndex > index ? 1 : -1])} aria-label={`Afficher l’image ${dotIndex + 1}`} aria-current={dotIndex === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral ${dotIndex === index ? 'w-7 bg-brand-coral' : 'w-2.5 bg-brand-rose/60 hover:bg-brand-rose'}`} data-id="element-170" data-mp="2apbn3zxe6wf9" data-mpi={dotIndex} />)}
          </div>
        </div>
      </div>
    </section>;
}